import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["thumbnailSrc", "title", "description"];
import { H4 } from 'UIComponents/elements/headings';
import { H3 } from 'foundations-components/transitional/components/H3';
import styled, { css, mediaQuery, theme } from 'academy-common-lib/utils/Styling';
import UIIcon from 'UIComponents/icon/UIIcon';
import { LeftIcon } from 'foundations-assets';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { useEffect, useState } from 'react';
import UIBox from 'UIComponents/layout/UIBox';
import { getProxyUrl, getPublicLang } from 'academy-common-lib/utils/url';

// @ts-expect-error Could not find a declaration file for module
import coursesCardThumbnail from 'bender-url!../../../../images/courses-card-thumbnail.webp';
// @ts-expect-error Could not find a declaration file for module
import certificationsCardThumbnail from 'bender-url!../../../../images/certifications-card-thumbnail.webp';
// @ts-expect-error Could not find a declaration file for module
import learningPathsCardThumbnail from 'bender-url!../../../../images/learningPaths-card-thumbnail.webp';
// @ts-expect-error Could not find a declaration file for module
import bootcampsCardThumbnail from 'bender-url!../../../../images/bootcamps-card-thumbnail.webp';
// @ts-expect-error Could not find a declaration file for module
import accreditationsCardThumbnail from 'bender-url!../../../../images/accreditations-card-thumbnail.webp';
// @ts-expect-error Could not find a declaration file for module
import guidedOnboardingCardThumbnail from 'bender-url!../../../../images/guidedOnboarding-card-thumbnail.webp';
import UIImage from 'UIComponents/image/UIImage';
import { publicNavButtonHoverStyle, publicNavButtonStyle } from '../publicNavButtonStyle';
import usageTracker from '../../../utils/usageTracker';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NavButton = styled.button.withConfig({
  displayName: "PublicPageNavDropdown__NavButton",
  componentId: "sc-1p6opkv-0"
})(["", " .button-title{margin-right:8px;}.down-caret{transition:transform 200ms ease-in-out;transform:translateY(1px);", "}&[aria-expanded='true']{", " .button-title{color:", ";text-decoration:underline;}.down-caret{transform:rotate(180deg);", "}}"], publicNavButtonStyle, mediaQuery('mobile', css(["position:absolute;right:12px;transform:rotate(-90deg);"])), publicNavButtonHoverStyle, props => props.theme.activeTheme === 'highContrast' ? props.theme.colors.HIGH_CONTRAST_LINK : props.theme.colors.CALYPSO_DARK, mediaQuery('mobile', css(["transform:rotate(90deg);"])));
const DropdownContent = styled.div.withConfig({
  displayName: "PublicPageNavDropdown__DropdownContent",
  componentId: "sc-1p6opkv-1"
})(["position:absolute;background-color:", ";border:1px solid ", ";box-shadow:0 4px 4px rgba(0,0,0,0.1);visibility:hidden;opacity:0;width:100%;left:0;padding:24px 96px;z-index:150;", " .text-section{margin-top:16px;margin-bottom:24px;", " h3{text-align:center;}p{text-align:center;max-width:462px;}}&[aria-hidden='false']{visibility:visible;opacity:1;}"], theme.colors.GYPSUM, theme.colors.GREAT_WHITE, mediaQuery('mobile', css(["padding:16px 16px;top:0;height:100%;overflow:scroll;"])), mediaQuery('mobile', css(["margin-top:0px;margin-bottom:0px;"])));
const DropdownCardGrid = styled.div.withConfig({
  displayName: "PublicPageNavDropdown__DropdownCardGrid",
  componentId: "sc-1p6opkv-2"
})(["width:100%;display:grid;grid-template-columns:1fr 1fr 1fr;grid-gap:24px;", ""], mediaQuery('mobile', css(["grid-template-columns:1fr;grid-gap:16px;"])));
const DropdownCardLink = styled(_ref => {
  let {
      thumbnailSrc,
      title,
      description
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const handleNavItemClick = e => {
    usageTracker.track('navInteraction', {
      action: 'nav-dropdown-item-click',
      href: e.currentTarget.href
    });
  };
  return /*#__PURE__*/_jsxs("a", Object.assign({
    onClick: handleNavItemClick,
    target: "_blank"
  }, rest, {
    children: [/*#__PURE__*/_jsx(UIImage, {
      alt: "card thumbnail",
      className: "card-thumbnail",
      height: 32,
      loading: "lazy",
      src: thumbnailSrc,
      width: 32
    }), /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(H4, {
        className: "m-top-1",
        style: {
          fontSize: 16
        },
        children: title
      }), /*#__PURE__*/_jsx("p", {
        children: description
      })]
    })]
  }));
}).withConfig({
  displayName: "PublicPageNavDropdown__DropdownCardLink",
  componentId: "sc-1p6opkv-3"
})(["display:flex;color:", ";width:100%;height:100%;background-color:", ";font-weight:400;font-size:14px;padding:16px;border-radius:4px;box-shadow:0 1px 5px rgba(33,51,67,0.12);p{margin-bottom:0;}.card-thumbnail{height:32px;width:32px;margin-right:12px;border-radius:4px;}&:hover{color:", ";text-decoration:none;box-shadow:0 8px 16px rgba(33,51,67,0.08);}"], theme.colors.OBSIDIAN, theme.colors.OLAF, theme.colors.OBSIDIAN);
const HomeButton = styled.button.withConfig({
  displayName: "PublicPageNavDropdown__HomeButton",
  componentId: "sc-1p6opkv-4"
})(["position:absolute;top:-", ";left:0;height:59px;width:80vw;background-color:", ";border:none;text-align:left;color:", ";padding:12px;z-index:150;.home-text{font-size:16px;font-weight:500;text-transform:uppercase;}"], theme.sizes.PUBLIC_NAV_REDUCED_HEIGHT, theme.colors.OLAF, theme.colors.HEFFALUMP);
const PublicPageNavDropdown = () => {
  const [expanded, setExpanded] = useState(false);
  useEffect(() => {
    usageTracker.track('navInteraction', {
      action: expanded ? 'nav-dropdown-open' : 'nav-dropdown-close'
    });
  }, [expanded]);
  return /*#__PURE__*/_jsxs("div", {
    onMouseLeave: () => setExpanded(false),
    style: {
      height: '100%'
    },
    children: [/*#__PURE__*/_jsxs(NavButton, {
      "aria-controls": "learningAcademy",
      "aria-expanded": expanded,
      onClick: () => setExpanded(true),
      onMouseEnter: () => setExpanded(true),
      children: [/*#__PURE__*/_jsx("span", {
        className: "button-title",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyPublic.publicNav.exploreAcademy"
        })
      }), /*#__PURE__*/_jsx(UIIcon, {
        className: "down-caret",
        color: theme.colors.EERIE,
        name: "down"
      })]
    }), /*#__PURE__*/_jsx(DropdownContent, {
      "aria-hidden": !expanded,
      "data-test-id": "public-nav-dropdown-content",
      id: "learningAcademy",
      children: /*#__PURE__*/_jsxs(TFlex, {
        align: "center",
        direction: "column",
        justify: "center",
        children: [/*#__PURE__*/_jsxs(UIBox, {
          className: "text-section",
          children: [/*#__PURE__*/_jsx(H3, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.publicNav.exploreAcademyContent.title"
            })
          }), /*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.publicNav.exploreAcademyContent.body"
            })
          })]
        }), /*#__PURE__*/_jsxs(DropdownCardGrid, {
          children: [/*#__PURE__*/_jsx(DropdownCardLink, {
            description: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.publicNav.exploreAcademyContent.links.courses.body"
            }),
            href: getProxyUrl('courses'),
            thumbnailSrc: coursesCardThumbnail,
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.publicNav.exploreAcademyContent.links.courses.title"
            })
          }), /*#__PURE__*/_jsx(DropdownCardLink, {
            description: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.publicNav.exploreAcademyContent.links.certifications.body"
            }),
            href: getProxyUrl('certification-overview'),
            thumbnailSrc: certificationsCardThumbnail,
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.publicNav.exploreAcademyContent.links.certifications.title"
            })
          }), /*#__PURE__*/_jsx(DropdownCardLink, {
            description: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.publicNav.exploreAcademyContent.links.bootcamps.body"
            }),
            href: "https://www.hubspot.com/academy/bootcamps/home",
            thumbnailSrc: bootcampsCardThumbnail,
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.publicNav.exploreAcademyContent.links.bootcamps.title"
            })
          }), /*#__PURE__*/_jsx(DropdownCardLink, {
            description: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.publicNav.exploreAcademyContent.links.learningPaths.body"
            }),
            href: getProxyUrl('learning-paths'),
            thumbnailSrc: learningPathsCardThumbnail,
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.publicNav.exploreAcademyContent.links.learningPaths.title"
            })
          }), /*#__PURE__*/_jsx(DropdownCardLink, {
            description: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.publicNav.exploreAcademyContent.links.accreditations.body"
            }),
            href: "https://www.hubspot.com/partnercredentials",
            thumbnailSrc: accreditationsCardThumbnail,
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.publicNav.exploreAcademyContent.links.accreditations.title"
            })
          }), getPublicLang() === 'en' && /*#__PURE__*/_jsx(DropdownCardLink, {
            description: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.publicNav.exploreAcademyContent.links.guidedOnboarding.body"
            }),
            href: "https://www.hubspot.com/academy/guided-onboarding",
            thumbnailSrc: guidedOnboardingCardThumbnail,
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.publicNav.exploreAcademyContent.links.guidedOnboarding.title"
            })
          })]
        })]
      })
    }), expanded && /*#__PURE__*/_jsxs(HomeButton, {
      onClick: () => setExpanded(false),
      children: [/*#__PURE__*/_jsx(LeftIcon, {
        size: "500"
      }), /*#__PURE__*/_jsx("span", {
        className: "home-text",
        children: "Home"
      })]
    })]
  });
};
export default PublicPageNavDropdown;